<template>

<div class="main social-media list-view">
	<div class="left-sidebarz filters">
		<div class="title">Add social media links to display on your website...</div>
		<button class="button primary" @click="save()">Save Social Media</button>
	</div>
	<div class="detail no-sub-header" v-if="!loading">
		<div class="social-media-settings">
			<label><i class="fab fa-facebook-square"></i> Facebook</label>
			<input v-model="socialMediaPreferences.FACEBOOK" type="text">
			<div class="message facebook">
				<message class="loading" :message="(facebookMessage == 'loading') ? null : facebookMessage" @transitionDone='facebookMessage = null' v-if="facebookMessage == 'loading'"></message>
				<i class="fas fa-spinner fa-spin" v-if="facebookMessage == 'loading'"></i>
			</div>

			<label><i class="fab fa-x-twitter"></i> X</label>
			<input v-model="socialMediaPreferences.TWITTER" type="text">
			<div class="message twitter">
				<message :message="(twitterMessage == 'loading') ? null : twitterMessage" @transitionDone="twitterMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="twitterMessage == 'loading'"></i>
			</div>

			<label><i class="fab fa-pinterest-square"></i> Pinterest</label>
			<input v-model="socialMediaPreferences.PINTREST" type="text">
			<div class="message pinterest">
				<message :message="(pintrestMessage == 'loading') ? null : pintrestMessage" @transitionDone="pintrestMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="pintrestMessage == 'loading'"></i>
			</div>

			<label><i class="fab fa-instagram"></i> Instagram</label>
			<input v-model="socialMediaPreferences.INSTAGRAM" type="text">
			<div class="message instagram">
				<message :message="(instagramMessage == 'loading') ? null : instagramMessage" @transitionDone="instagramMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="instagramMessage == 'loading'"></i>
			</div>

			<label><i class="fab fa-youtube-square"></i> YouTube</label>
			<input v-model="socialMediaPreferences.YOUTUBE" type="text">
			<div class="message youtube">
				<message :message="(youtubeMessage == 'loading') ? null : youtubeMessage" @transitionDone="youtubeMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="youtubeMessage == 'loading'"></i>
			</div>

			<label><i class="fa fa-fire"></i> BBB</label>
			<input v-model="socialMediaPreferences.BBB" type="text">
			<div class="message bbb">
				<message :message="(bbbMessage == 'loading') ? null : bbbMessage" @transitionDone="bbbMessage = null" class="loading"></message>
				<i class="fas fa-spinner fa-spin" v-if="bbbMessage == 'loading'"></i>
			</div>

		</div>
	</div>
    <loading v-else></loading>

	<help-popup :helpLink="{84:'Social Media'}" :tours="false"></help-popup>

</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'social-media',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			socialMediaPreferences: {
				'FACEBOOK': null,
				'TWITTER': null,
				'PINTREST': null,
				'INSTAGRAM': null,
				'YOUTUBE': null,
				'BBB': null
			},
			socialMediaPreferencesCopy: {
				'FACEBOOK': null,
				'TWITTER': null,
				'PINTREST': null,
				'INSTAGRAM': null,
				'YOUTUBE': null,
				'BBB': null
			},
			facebookMessage: null,
			twitterMessage: null,
			pintrestMessage: null,
			instagramMessage: null,
			youtubeMessage: null,
			bbbMessage: null
		}
	},
	created() {
		this.fetchData()
	},
	methods: {
		fetchData() {
            this.loading = true
            let preferenceCodes = ['FACEBOOK', 'TWITTER', 'PINTREST', 'INSTAGRAM', 'YOUTUBE', 'BBB']
            this.apiCall({ destination: 'get_item_preference', data: { preference_code: preferenceCodes } }).then(obj => {
                this.loading = false
                for (let i = 0; i < preferenceCodes.length; i++) {
					this.socialMediaPreferences[preferenceCodes[i]] = this.$copy(obj[preferenceCodes[i]])
                    this.socialMediaPreferencesCopy[preferenceCodes[i]] = this.$copy(obj[preferenceCodes[i]])
                }
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		save() {
			if (this.socialMediaPreferences['FACEBOOK'] != this.socialMediaPreferencesCopy['FACEBOOK']) {
				this.facebookMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'FACEBOOK', value: this.socialMediaPreferences['FACEBOOK'] } }).then(obj => {
					this.facebookMessage = obj.message
					this.socialMediaPreferencesCopy['FACEBOOK'] = this.$copy(this.socialMediaPreferences['FACEBOOK'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['TWITTER'] != this.socialMediaPreferencesCopy['TWITTER']) {
				this.twitterMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'TWITTER', value: this.socialMediaPreferences['TWITTER'] } }).then(obj => {
					this.twitterMessage = obj.message
					this.socialMediaPreferencesCopy['TWITTER'] = this.$copy(this.socialMediaPreferences['TWITTER'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['PINTREST'] != this.socialMediaPreferencesCopy['PINTREST']) {
				this.pintrestMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'PINTREST', value: this.socialMediaPreferences['PINTREST'] } }).then(obj => {
					this.pintrestMessage = obj.message
					this.socialMediaPreferencesCopy['PINTREST'] = this.$copy(this.socialMediaPreferences['PINTREST'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['INSTAGRAM'] != this.socialMediaPreferencesCopy['INSTAGRAM']) {
				this.instagramMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'INSTAGRAM', value: this.socialMediaPreferences['INSTAGRAM'] } }).then(obj => {
					this.instagramMessage = obj.message
					this.socialMediaPreferencesCopy['INSTAGRAM'] = this.$copy(this.socialMediaPreferences['INSTAGRAM'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['YOUTUBE'] != this.socialMediaPreferencesCopy['YOUTUBE']) {
				this.youtubeMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'YOUTUBE', value: this.socialMediaPreferences['YOUTUBE'] } }).then(obj => {
					this.youtubeMessage = obj.message
					this.socialMediaPreferencesCopy['YOUTUBE'] = this.$copy(this.socialMediaPreferences['YOUTUBE'])
				}).catch(err => {
					console.log(err)
				})
			}
			if (this.socialMediaPreferences['BBB'] != this.socialMediaPreferencesCopy['BBB']) {
				this.bbbMessage = 'loading'
				this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'BBB', value: this.socialMediaPreferences['BBB'] } }).then(obj => {
					this.bbbMessage = obj.message
					this.socialMediaPreferencesCopy['BBB'] = this.$copy(this.socialMediaPreferences['BBB'])
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.social-media-settings {
	display: grid;
	grid-gap: 0.5rem 1rem;
	grid-template-columns: 5rem 1fr 150px;
	align-items: center;
}
label {
    grid-column: 1 / 2;
	i {
		font-size: 3em;
    display: block;
	}
}
/*label { grid-column: span 2; }*/
input { grid-column: 2 / 3; }
.message { margin: 0; grid-column: 3 / 4; align-self: center; }
</style>
